// import Header from "../../components/header/header"
import VFrame from "../../components/video/video-frame";
import {
  Typography,
  Avatar,
  Button,
  Box,
  Card,
  CardHeader,
  CardContent,
  CardMedia,
} from "@mui/material";
import { Instagram, Facebook, YouTube, WhatsApp } from "@mui/icons-material";
import { Link } from "react-router-dom";
// import "./home.css";
import data from "../../video-links.json";
import reviewData from "../../reviews.json";
import cardImg from "../../images/setup.jpg";
// import clientImg from "../../images/client-1.jpg";
// import YoutubeEmbed from "../../components/video/youtube-embed";

const Home = () => {
  return (
    <>
      <div className="hero">
        <div className="overlay">
          <Box
            padding="8px"
            display="grid"
            gridTemplateColumns="repeat(12, 1fr)"
            gridTemplateRows="repeat(3, 1fr)"
            alignItems="center"
            justifyContent="space-evenly"
            height="100%"
          >
            <Box
              gridColumn={{ xs: "span 12", md: "2/span 8" }}
              gridRow="1/3"
              className="hero_note"
            >
              <Typography color="secondary" variant="h3">
                We provide stunning video editing services
              </Typography>
              <Typography variant="body1" color="white">
                With over 3 years of strong experience in editing and producing
                professional material such as camera footage, sound files, and
                graphics, with understanding of digital software and video
                editing .
              </Typography>
            </Box>
            <Box
              display="flex"
              flexDirection="row"
              justifyContent={{ xs: "space-evenly", md: "space-between" }}
              gridColumn={{ xs: "2/span 8", md: "2/ span 2" }}
              gridRow="3/4"
              className="btn_group"
            >
              <Link to="/gallery" style={{ textDecoration: "none" }}>
                <Button variant="contained">
                  <Typography variant="button">Gallery</Typography>
                </Button>
              </Link>
              <Link to="/contact" style={{ textDecoration: "none" }}>
                <Button variant="outlined" color="secondary">
                  <Typography variant="button">Contact</Typography>
                </Button>
              </Link>
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent=" space-evenly"
              gridColumn="12 /span 1"
              gridRow="3/4"
              justifySelf={{ md: "flex-end" }}
              className="social_links"
            >
              <a href="https://www.youtube.com" target={{ target: "blank" }}>
                <Avatar sx={{ bgcolor: "#D9C750" }}>
                  <YouTube />
                </Avatar>
              </a>
              <a href="https://www.facebook.com" target={{ target: "blank" }}>
                <Avatar sx={{ bgcolor: "#D9C750" }}>
                  <Facebook />
                </Avatar>
              </a>
              <Avatar sx={{ bgcolor: "#D9C750" }}>
                <Instagram />
              </Avatar>
              <Avatar sx={{ bgcolor: "#D9C750" }}>
                <WhatsApp />
              </Avatar>
            </Box>
          </Box>
        </div>
      </div>

      {/* .....................PROJECTS...................... */}

      <div className="projects">
        <Typography component="h4" variant="h4" sx={{ padding: "1rem" }}>
          Past Projects
        </Typography>
        <Box
          display="flex"
          flexDirection={{ xs: "column", md: "row" }}
          flexWrap="wrap"
          justifyContent="space-evenly"
        >
          {data.videos
            .filter((data) => {
              return data.source === "youtube";
            })
            .map((dat) => {
              return (
                <Box
                  sx={{ width: { xs: "90%", md: "45%" }, margin: "auto" }}
                  key={dat.id}
                  className="vid"
                >
                  <VFrame
                    url={dat.link}
                    title={dat.title}
                    config={data.config}
                  />
                  {/* <YoutubeEmbed videoID={dat.vID} title={dat.title} /> */}
                </Box>
              );
            })}
        </Box>
        <Link to="/gallery" style={{ textDecoration: "none" }}>
          <Button variant="contained" color="secondary">
            <Typography variant="button">Go to Gallery</Typography>
          </Button>
        </Link>
      </div>

      {/* .....................SERVICES...................... */}

      <div className="services">
        <Typography component={"h4"} variant="h4" className="servHeader">
          Our Services
        </Typography>
        <Box
          display="flex"
          flexDirection={{ xs: "column", md: "row" }}
          flexWrap="wrap"
          justifyContent={"space-evenly"}
        >
          <Card
            sx={{
              width: { xs: "90%", md: "30%" },
              height: "auto",
              bgcolor: "#D9C750",
              margin: { xs: "1rem auto", md: "auto" },
            }}
          >
            <CardHeader title="Card Title" />
            <CardMedia
              component="img"
              height="auto"
              image={cardImg}
              alt="Computer Setup"
            />
            <CardContent>
              <Typography variant="body2">
                Some details about what you want. Lizards are a widespread group
                of squamate reptiles, with over 6,000 species, ranging across
                all continents except Antarctica
              </Typography>
            </CardContent>
          </Card>
          <Card
            sx={{
              width: { xs: "90%", md: "30%" },
              height: "auto",
              bgcolor: "#D9C750",
              margin: { xs: "1rem auto", md: "auto" },
            }}
          >
            <CardHeader title="Card Title" />
            <CardMedia
              component="img"
              height="auto"
              image={cardImg}
              alt="Computer Setup"
            />
            <CardContent>
              <Typography variant="body2">
                Some details about what you want. Lizards are a widespread group
                of squamate reptiles, with over 6,000 species, ranging across
                all continents except Antarctica
              </Typography>
            </CardContent>
          </Card>
          <Card
            sx={{
              width: { xs: "90%", md: "30%" },
              height: "auto",
              bgcolor: "#D9C750",
              margin: { xs: "1rem auto", md: "auto" },
            }}
          >
            <CardHeader title="Card Title" />
            <CardMedia
              component="img"
              height="auto"
              image={cardImg}
              alt="Computer Setup"
            />
            <CardContent>
              <Typography variant="body1">
                Some details about what you want. Lizards are a widespread group
                of squamate reptiles, with over 6,000 species, ranging across
                all continents except Antarctica
              </Typography>
            </CardContent>
          </Card>
        </Box>
      </div>

      {/* .....................REVIEWS...................... */}

      <div className="reviews">
        <Typography variant="h4" component={"h4"}>
          What our Clients say
        </Typography>
        <Box
          className="slideshow"
          sx={{
            display: "flex",
            flexFlow: { xs: "column nowrap", md: "row wrap" },
            alignItems: "center",
            justifyContent: "space-around",
          }}
        >
          {reviewData.reviews.map((rev) => {
            return (
              <Card
                sx={{
                  width: { xs: "80%", md: "25%" },
                  height: "13rem",
                  margin: ".5rem",
                  display: "grid",
                  // flexFlow:"row wrap"
                  gridTemplateColumns: "repeat(7,1fr)",
                  gridTemplateRows: "auto",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  // bgcolor: "primary.dark",
                  bgcolor: "secondary.main",
                }}
              >
                <CardContent
                  sx={{
                    gridColumn: "2/7",
                    bgcolor: "primary.dark",
                    color: "secondary.main",
                  }}
                >
                  <Typography component={"p"} variant="body2">
                    {rev.review}
                  </Typography>
                </CardContent>
                <Avatar
                  alt="Client name"
                  src={rev.imagesrc}
                  sx={{
                    width: 56,
                    height: 56,
                    margin: 0,
                    // gridColumnStart: "2",
                    gridColumn: "2/3",
                  }}
                  variant="rounded"
                />
                {/* insert client image here */}
                {/* </Avatar> */}
                <Box sx={{ gridColumn: "3/7" }}>
                  <Typography variant="body1" component="p">
                    {rev.name}
                  </Typography>
                  <Typography variant="body2" component="p">
                    {rev.role} at {rev.company}
                  </Typography>
                </Box>
              </Card>
            );
          })}

          {/* <Card
            sx={{
              width: { xs: "80%", md: "25%" },
              height: "13rem",
              margin: "auto",
              display: "grid",
              // flexFlow:"row wrap"
              gridTemplateColumns: "repeat(6,1fr)",
              gridTemplateRows: "auto",
              alignItems: "center",
              justifyContent: "space-around",
              bgcolor: "primary.dark",
              color: "secondary.main",
            }}
          >
            <CardContent sx={{ gridColumn: "2/7" }}>
              <Typography component={"p"} variant="body2">
                This is what I think about that. It is supposed to make you
                expect something similar. A second Slide
              </Typography>
            </CardContent>
            <Avatar
              alt="Client name"
              src={clientImg}
              sx={{
                width: 56,
                height: 56,
                margin: 0,
                // gridColumnStart: "2",
                gridColumn: "2/3",
              }}
            >
            </Avatar>
            <Box sx={{ gridColumn: "3/5" }}>
              <Typography variant="body1" component="p">
                Name of client
              </Typography>
              <Typography variant="body2" component="p">
                Position at Company/Business
              </Typography>
            </Box>
          </Card>
          <Card
            sx={{
              width: { xs: "80%", md: "25%" },
              height: "13rem",
              margin: "auto",
              display: "grid",
              // flexFlow:"row wrap"
              gridTemplateColumns: "repeat(6,1fr)",
              gridTemplateRows: "auto",
              alignItems: "center",
              justifyContent: "space-around",
              bgcolor: "primary.dark",
              color: "secondary.main",
            }}
          >
            <CardContent sx={{ gridColumn: "2/7" }}>
              <Typography component={"p"} variant="body2">
                This is what I think about that. It is supposed to make you
                expect something similar. Yet another
              </Typography>
            </CardContent>
            <Avatar
              alt="Client name"
              src={clientImg}
              sx={{
                width: 56,
                height: 56,
                margin: 0,
                // gridColumnStart: "2",
                gridColumn: "2/3",
              }}
            >
            </Avatar>
            <Box sx={{ gridColumn: "3/5" }}>
              <Typography variant="body1" component="p">
                Name of client
              </Typography>
              <Typography variant="body2" component="p">
                Position at Company/Business
              </Typography>
            </Box>
          </Card> */}
        </Box>
      </div>
    </>
  );
};

export default Home;
